import "./about.css"
import about_us from "../../../assets/about-us.png";
import React from "react";

function AboutUs() {
    return (
        <div className="about">
            <div className="about_left_side">
                <img src={about_us} alt=""/>
            </div>
            <div className="about_right_side">
                <h1 className="about_heading">About Us</h1>
                <p className="about_text">Introducing ChoiceTrade, the premier destination for active traders,
                    self-directed investors, and
                    stock market enthusiasts alike. Founded with a commitment to empowering investors of all levels,
                    ChoiceTrade offers a seamless and intuitive web-based trading platform designed to simplify the
                    trading experience.
                </p>

                <p className="about_text">At ChoiceTrade, we understand that navigating the complexities of the stock
                    market can be daunting.
                    That's why we've crafted a platform that prioritizes clarity and ease of use, eliminating
                    unnecessary clutter and complications. Whether you're a seasoned trader or just dipping your toes
                    into the world of investing, ChoiceTrade provides the tools and resources you need to make informed
                    decisions with confidence.
                </p>

                <p className="about_text">
                    Our mission is simple. to provide our customers with a true "choice" in their trading journey. With
                    ChoiceTrade, you can trust that the benefits, convenience, and service far exceed the commissions
                    you'll pay, no matter your level of trading sophistication.
                </p>

                <p className="about_text">
                    Join us at ChoiceTrade and experience the difference for yourself. Take control of your financial
                    future with a platform that puts your needs first. Welcome to a new era of trading excellence.
                    Welcome to ChoiceTrade.</p>
            </div>
        </div>
    )
}

export default AboutUs